export const LIMIT_ORDERS_ENABLED = 'enableLimitOrders'
